<style>
/* .table-responsive,
.dataTables_scrollBody {
    overflow: visible !important;
} */
/* div.dataTables_scrollBody.dropdown-visible {
  overflow: visible !important;
} */

/* table .dropdown-menu {
    position: fixed !important;
    top: 50% !important;
    left: 92% !important;
    transform: translate(-92%, -50%) !important;
} */

/* .dataTables_scrollHead{
    position: static !important;
} */

#berusahaPICMonitor_info,
#berusahaPICMonitor_paginate,
#berusahaPICMonitor_filter {
  display: none;
}
</style>
<template>
  <div>
    <div v-if="show" :show="show" class="text-center">
      <img :src="require('@/assets/loadingfish.gif')" alt="Loading..." width="150px" />
      <p id="cancel-label">Sedang memuat data...</p>

    </div>
    <div v-if="!show">
      <!-- <div style="overflow-x:auto;"> -->
      <div class="d-flex justify-content-between">
        <div>
          <button type="button" class="btn btn-success" @click="exportData">
            <i class="fa fa-file-text-o"></i> Excel
          </button>
        </div>
        <div class="d-flex">
          <div class="d-flex">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mr-2 mb-0">Search: </label>
              <input v-model="search.value" type="text" class="form-control" id="search">
            </div>
            <div>
              <select v-model="search.field" class="form-control">
                <option value="nama_pemohon">Nama Pemohon</option>
                <option value="nomor_permohonan">Nomor Pemohon</option>
                <option value="jenis_kegiatan">Jenis Kegiatan</option>
                <option value="nama_perairan">Nama Perairan</option>
                <option value="lokasi">Provinsi</option>
                <!-- <option value="status_verdok">Status Verdok</option> -->
                <option value="status_permohonan">Status Permohonan</option>
                <option value="keterangan_status">Keterangan Status</option>
                <option value="tanggal_pada_permohonan">Tgl Permohonan</option>
                <option value="tanggal_proses">Tgl Proses</option>
                <option value="pic_name">PIC Pentek</option>
              </select>
            </div>
          </div>
          <div class="d-flex ml-4">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mb-0">Sort By: </label>
            </div>
            <div>
              <select v-model="sort.field" class="form-control">
                <option value="createdAt">Tgl Submit</option>
                <option value="tanggal_pada_permohonan">Tgl Permohonan</option>
                <option value="tanggal_proses">Tgl Proses</option>
              </select>
            </div>
            <div class="ml-2">
              <select v-model="sort.direction" class="form-control">
                <option value="DESC">DESC</option>
                <option value="ASC">ASC</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table id="berusahaPICMonitor" class="table" style="width: 100%">
          <thead>
            <tr>
              <th class="all">No</th>
              <th class="all">Nama Pemohon</th>
              <th style="display:none">NIB</th>
              <th style="display:none">Nomor Proyek</th>
              <th style="display:none">KBLI</th>
              <th style="display:none">Jenis Proyek</th>
              <th style="display:none">Risiko</th>
              <th style="display:none">Skala Usaha</th>
              <th style="display:none">PIC Dokumen</th>
              <th class="all">Nomor Pemohon</th>
              <th class="all">Jenis Kegiatan</th>
              <th class="all">Nama Perairan</th>
              <th class="all">Provinsi</th>
              <!-- <th>Status Verdok</th> -->
              <th>Status Permohonan</th>
              <th>Keterangan Status</th>
              <th class="all">Tgl. Permohonan</th>
              <th>Tgl. Proses</th>
              <th>Tgl. Berlaku Tagihan</th>
              <th>Status Tagihan</th>
              <th>PIC Pentek</th>
              <th style="text-align: center">File</th>
              <!-- <th>File Surat Tugas</th>
                        <th>File Undangan</th>
                        <th>File BA</th>
                        <th>File Memo</th> -->
              <th class="all">Aksi</th>
            </tr>
            <!-- <tr>
                        <th>Bukti Pembayaran</th>
                        <th>Surat Tugas</th>
                        <th>Undangan</th>
                        <th>BA</th>
                        <th>Memo</th>
                        <th>Persetujuan</th>
                    </tr> -->
          </thead>
          <tbody>
            <tr v-for="(row, index) in dataPermohonan" :key="row.id">
              <td class="sticky-col second-col">
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                  index + pagination.firstInPage }}</span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">{{ index + pagination.firstInPage }}</div>
                </span>
              </td>
              <td class="sticky-col second-col">
                <div v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                  <div style="width: 250px;" class="text-wrap">{{
                    row.nama_pemohon
                  }}</div>
                </div>
                <div v-else style="width: 250px;" class="text-wrap">
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    <div>{{ row.nama_pemohon }}</div>
                  </div>
                </div>
                <div v-if="row.tipe_permohonan == 'Multi KBLI' & row.tipe_multi_kbli == 'Mengikuti'"
                  class="text-secondary" style="font-size: 12px;">
                  Pendukung
                </div>
                <div v-else-if="row.tipe_permohonan == 'Multi KBLI' & row.tipe_multi_kbli == 'Proses'"
                  class="text-primary" style="font-size: 12px;">
                  Proses
                </div>
              </td>
              <td style="display: none">{{ row.nib_pemohon }}</td>
              <td style="display: none">{{ row.nomor_proyek }}</td>
              <td style="display: none">{{ row.kbli }}</td>
              <td style="display: none">{{ row.jenis_proyek }}</td>
              <td style="display: none">{{ row.risiko }}</td>
              <td style="display: none">{{ row.skala_usaha }}</td>
              <td style="display: none">{{ row.nama_pic_verdok }}</td>
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                  row.nomor_permohonan
                }}</span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ row.nomor_permohonan }}
                  </div>
                </span>
              </td>
              <td>
                <div class="text-wrap" v-if="row.status_verdok == 'Perbaikan Persyaratan'"
                  style="color: red;width: 300px;">{{
                    row.jenis_kegiatan
                  }}</div>
                <div class="text-wrap" v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' }, { width: '300px' }
                  ]">
                    {{ row.jenis_kegiatan }}
                  </div>
                </div>
              </td>
              <td>
                <div class="text-wrap" v-if="row.status_verdok == 'Perbaikan Persyaratan'"
                  style="color: red;width: 300px;">{{
                    row.nama_perairan
                  }}</div>
                <div class="text-wrap" v-else>
                  <div :style="[
                    row.nama_perairan ? { color: 'green' } : { color: 'black' }, { width: '300px' }
                  ]">
                    {{ row.lokasi }}
                  </div>
                </div>
              </td>
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                  row.lokasi
                }}</span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ row.lokasi }}
                  </div>
                </span>
              </td>
              <!-- <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                  row.status_verdok
                  }}</span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ row.status_verdok }}
                  </div>
                </span>
              </td> -->
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                  row.status_permohonan
                }}</span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ row.status_permohonan }}
                  </div>
                </span>
              </td>
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                  row.keterangan_status
                }}</span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ row.keterangan_status }}
                  </div>
                </span>
              </td>
              <td v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                {{ format_date(row.tanggal_pada_permohonan) }}
              </td>
              <td v-else :style="[row.prioritas ? { color: 'green' } : { color: 'black' }]">
                {{ format_date(row.tanggal_pada_permohonan) }}
              </td>
              <td v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                {{ format_date(row.tanggal_proses) }}
              </td>
              <td v-else :style="[row.prioritas ? { color: 'green' } : { color: 'black' }]">
                {{ format_date(row.tanggal_proses) }}
              </td>
              <td v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                <template v-if="row.status_tagihan_iii != null">
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_iii) }}
                </template>
                <template v-else-if="
                  row.status_tagihan_ii != null &&
                  row.status_tagihan_i != null
                ">
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_ii) }}
                </template>
                <template v-else>
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_i) }}
                </template>
              </td>
              <td v-else :style="[row.prioritas ? { color: 'green' } : { color: 'black' }]">
                <template v-if="row.status_tagihan_iii != null">
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_iii) }}
                </template>
                <template v-else-if="
                  row.status_tagihan_ii != null && row.status_tagihan_i != null
                ">
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_ii) }}
                </template>
                <template v-else>
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_i) }}
                </template>
              </td>
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                  <span v-if="row.status_tagihan_iii != null">
                    {{ row.status_tagihan_iii }}
                  </span>
                  <span v-else-if="
                    row.status_tagihan_ii != null &&
                    row.status_tagihan_i != null
                  ">
                    {{ row.status_tagihan_ii }}
                  </span>
                  <span v-else>
                    {{ row.status_tagihan_i }}
                  </span>
                </span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    <span v-if="row.status_tagihan_iii != null">
                      {{ row.status_tagihan_iii }}
                    </span>
                    <span v-else-if="
                      row.status_tagihan_ii != null &&
                      row.status_tagihan_i != null
                    ">
                      {{ row.status_tagihan_ii }}
                    </span>
                    <span v-else>
                      {{ row.status_tagihan_i }}
                    </span>
                  </div>
                </span>
              </td>
              <td>
                {{ row.pic_name }}
              </td>
              <td>
                <div style="width: 250px">
                  <div class="row">
                    <div class="col-md-8">
                      <select v-model="row.selectedFile" style="width: 150px; margin-right: 10px" class="form-select"
                        aria-label="Default select example">
                        <option disabled value="">- Pilih File -</option>
                        <option value="verdok" :disabled="row.file_ba_verdok == null
                          ">
                          Verdok
                        </option>
                        <!-- Option File Tagihan -->
                        <option value="tagihan_1" :disabled="row.file_tagihan_i == null">
                          <i class="la la-edit"></i> Tagihan 1
                        </option>

                        <option value="tagihan_2" :disabled="row.file_tagihan_ii == null">
                          <i class="la la-edit"></i> Tagihan 2
                        </option>

                        <option value="tagihan_3" :disabled="row.file_tagihan_iii == null">
                          <i class="la la-edit"></i> Tagihan 3
                        </option>

                        <option value="pembayaran" :disabled="row.bukti_pembayaran == null">
                          Bukti Pembayaran
                        </option>
                        <option value="surattugas" :disabled="row.filename_final_surat_tugas == null &&
                          row.filename_konsep_surat_tugas == null
                          ">
                          Surat Tugas
                        </option>
                        <option value="undangan" :disabled="row.filename_final_undangan == null &&
                          row.filename_konsep_undangan == null
                          ">
                          Undangan
                        </option>
                        <option value="ba" :disabled="row.file_ba_vertek == null">
                          Berita Acara
                        </option>
                        <option value="shp" :disabled="row.file_shp == null">
                          File SHP
                        </option>

                        <option value="resume" :disabled="row.file_resume_permohonan == null &&
                          row.file_resume_permohonan == null
                          ">
                          Resume Permohonan
                        </option>
                        <option value="persetujuan" :disabled="row.file_persetujuan == null">
                          Final Surat Persetujuan
                        </option>
                        <!-- <option value="epersetujuan" :disabled="row.file_izin_ttd == null">
                      Final Surat Persetujuan Elektronik
                    </option> -->

                        <option value="oss" :disabled="row.file_final_oss == null">
                          Final Persetujuan OSS
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4 mt-2">
                      <span v-if="
                        row.file_ba_verdok != null &&
                        row.selectedFile == 'verdok'
                      ">
                        <a :href="row.file_ba_verdok" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file verifikasi dokumen" /></a>
                      </span>

                      <!-- Download File Tagihan -->
                      <span v-if="
                        row.file_tagihan_iii != null &&
                        row.selectedFile == 'tagihan_3'
                      ">
                        <a :href="row.file_tagihan_iii" target="_blank"><i class="fa fa-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file tagihan 3" /></a>
                      </span>
                      <span v-if="
                        row.file_tagihan_ii != null &&
                        row.selectedFile == 'tagihan_2'
                      ">
                        <a :href="row.file_tagihan_ii" target="_blank"><i class="fa fa-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file tagihan 2" />
                        </a>
                      </span>

                      <span v-if="
                        row.file_tagihan_i != null &&
                        row.selectedFile == 'tagihan_1'
                      ">
                        <a :href="row.file_tagihan_i" target="_blank"><i class="fa fa-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file tagihan 1" /></a>
                      </span>

                      <!-- <br> -->
                      <span v-if="
                        row.bukti_pembayaran != null &&
                        row.selectedFile == 'pembayaran'
                      ">
                        <a :href="row.bukti_pembayaran" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file bukti pembayaran" />
                        </a>
                      </span>

                      <span v-if="
                        row.filename_final_surat_tugas != null &&
                        row.selectedFile == 'surattugas'
                      ">
                        <a :href="row.filename_final_surat_tugas" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file surat tugas" /></a>
                      </span>
                      <span v-else-if="
                        row.filename_konsep_surat_tugas != null &&
                        row.selectedFile == 'surattugas'
                      ">
                        <a :href="row.filename_konsep_surat_tugas" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file surat tugas" /></a>
                      </span>

                      <span v-if="
                        row.filename_final_undangan != null &&
                        row.selectedFile == 'undangan'
                      ">
                        <a :href="row.filename_final_undangan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file undangan" /></a>
                      </span>
                      <span v-else-if="
                        row.filename_konsep_undangan != null &&
                        row.selectedFile == 'undangan'
                      ">
                        <a :href="row.filename_konsep_undangan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file undangan" /></a>
                      </span>

                      <span v-if="
                        row.file_ba_vertek != null && row.selectedFile == 'ba'
                      ">
                        <a :href="row.file_ba_vertek" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file berita acara" /></a>
                      </span>

                      <span v-if="
                        row.file_final_memorandum != null &&
                        row.selectedFile == 'memo'
                      ">
                        <a :href="row.file_final_memorandum" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file memo" /></a>
                      </span>
                      <span v-else-if="
                        row.file_konsep_memorandum != null &&
                        row.selectedFile == 'memo'
                      ">
                        <a :href="row.file_konsep_memorandum" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file memo" /></a>
                      </span>

                      <span v-if="
                        row.file_persetujuan != null &&
                        row.selectedFile == 'persetujuan'
                      ">
                        <a :href="row.file_persetujuan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file persetujuan" />
                        </a>
                      </span>

                      <span v-if="
                        row.file_izin_ttd != null &&
                        row.selectedFile == 'epersetujuan'
                      ">
                        <a :href="row.file_izin_ttd" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file persetujuan elektronik" />
                        </a>
                      </span>

                      <span v-if="
                        row.file_final_oss != null &&
                        row.selectedFile == 'oss'
                      ">
                        <a :href="row.file_final_oss" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file persetujuan OSS" />
                        </a>
                      </span>

                      <span v-if="
                        row.file_resume_permohonan != null &&
                        row.selectedFile == 'resume'
                      ">
                        <a :href="row.file_resume_permohonan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file resume permohonan" />
                        </a>
                      </span>

                      <span v-if="
                        row.file_shp != null &&
                        row.selectedFile == 'shp'
                      ">
                        <a :href="row.file_shp" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top" title="Unduh file SHP" />
                        </a>
                      </span>



                    </div>
                  </div>

                  <!-- <b-form-select style="width: 150px;margin-right: 20px;" v-model="row.selectedFile"
                                    :options="optionsFile"></b-form-select> -->
                </div>
              </td>

              <!-- <td>
                            <div>
                                <span v-if="row.file_tagihan_iii != null">
                                    <a :href="row.file_tagihan_iii" target="_blank"><i class="fa fa-download"
                                            aria-hidden="true" /> Unduh Tagihan</a>
                                </span>
                                <span v-else-if="row.file_tagihan_ii != null && row.file_tagihan_i != null">
                                    <a :href="row.file_tagihan_ii" target="_blank"><i class="fa fa-download"
                                            aria-hidden="true" /> Unduh Tagihan</a>
                                </span>
                                <span v-else-if="row.file_tagihan_i != null">
                                    <a :href="row.file_tagihan_i" target="_blank"><i class="fa fa-download"
                                            aria-hidden="true" /> Unduh Tagihan</a>
                                </span>
                            </div>
                            <span v-if="row.bukti_pembayaran != null">
                                <a :href="row.bukti_pembayaran" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh Bukti Pembayaran</a>
                            </span>
                        </td>
                        <td>
                            <span v-if="row.filename_final_surat_tugas != null">
                                <a :href="row.filename_final_surat_tugas" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                            <span v-else-if="row.filename_konsep_surat_tugas != null">
                                <a :href="row.filename_konsep_surat_tugas" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                        </td>
                        <td>
                            <span v-if="row.filename_final_undangan != null">
                                <a :href="row.filename_final_undangan" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                            <span v-else-if="row.filename_konsep_undangan != null">
                                <a :href="row.filename_konsep_undangan" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                        </td>
                        <td>
                            <span v-if="row.file_ba_vertek != null">
                                <a :href="row.file_ba_vertek" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                        </td>
                        <td>
                            <span v-if="row.file_final_memorandum != null">
                                <a :href="row.file_final_memorandum" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                            <span v-else-if="row.file_konsep_memorandum != null">
                                <a :href="row.file_konsep_memorandum" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                        </td>
                        <td>
                            <span v-if="row.file_persetujuan != null">
                                <a :href="row.file_persetujuan" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                        </td> -->

              <td v-if="row.tipe_multi_kbli == 'Mengikuti'">
                <b-button size="sm" variant="info" data-toggle="tooltip" data-placement="top" title="Detail" @click="
                  $router.push('/app/penambahan-kbli/detail-perizinan/' + row.id)
                  " class="text-white m-1"><i class="fa fa-eye" /> Detail</b-button>
              </td>
              <td v-else>
                <b-button size="sm" variant="info" data-toggle="tooltip" data-placement="top" title="Detail" @click="
                  $router.push('/app/penambahan-kbli/detail-perizinan/' + row.id)
                  " class="text-white"><i class="fa fa-eye" /> Detail</b-button>

                <!-- <b-button size="sm" style="margin-left: 5px" v-if="
                  row.perlu_pnbp == true && row.bukti_pembayaran == null && row.file_tagihan_i != null
                " @click="getBayar(row.id)" variant="info"><i class="fa fa-money" /> Pembayaran</b-button> -->

                <b-button v-if="canCheckStatusBayar(row)" size="sm" variant="secondary"
                  class="d-inline-flex align-items-center px-3 py-2 shadow-sm" @click="checkStatusBayar(row)">
                  <i class="fa fa-search mr-2"></i>Cek Status Pembayaran
                </b-button>

                <b-button size="sm" style="margin-left: 5px" v-if="
                  ((row.perlu_pnbp == true && row.status_permohonan == 'Pembayaran PNBP') || (row.perlu_pnbp == false && row.status_permohonan == 'Tim Teknis Pembuatan Berita Acara Hasil Penilaian Teknis')) &&
                  (row.status_persetujuan == null || row.status_persetujuan == 'Telah diupload') &&
                  user.role === 'pic_monitor'
                " @click="getDataUploadKonsep(row)" variant="success"><i class="fa fa-cloud-upload" />{{
                  row.status_persetujuan == null ? ' Upload' : ' Edit' }} File Konsep
                  Persetujuan</b-button>


                <b-button size="sm" style="margin-left: 5px" v-if="
                  (row.status_persetujuan == 'Telah diupload' || row.status_persetujuan == 'Telah dikirim ke Portal Coofis') &&
                  user.role === 'pic_monitor'
                " @click="kirimDocument(row.id)" variant="primary"><i class="fa fa-cloud-upload" /> Kirim {{
                  row.status_persetujuan == 'Telah dikirim ke Portal Coofis' ? 'Ulang' : '' }} Dokumen ke
                  Coofis </b-button>

                <b-button size="sm" style="margin-left: 5px" v-if="
                  row.status_persetujuan == 'Sudah ditandatangani oleh Menteri KP' && (row.status_permohonan != 'Selesai' || row.status_permohonan == 'Selesai') &&
                  user.role === 'pic_monitor'
                " @click="getDetailPerDokumen(row)" variant="primary"><i class="fa fa-check" /> {{
                  row.status_permohonan
                    == 'Selesai' ? 'Finalisasi Ulang Permohonan' :'Finalisasi Permohonan'}} </b-button>

                <!-- <b-dropdown variant="primary" split text="Aksi" class="me-3">
                                <b-dropdown-item @click="$router.push('/app/penambahan-kbli/detail-verifikasi-teknis/'+ row.id)">Penilaian Teknis</b-dropdown-item>
                                <b-dropdown-item v-if="row.status_tandatangan_undangan === true" @click="$router.push('/app/penambahan-kbli/ba/'+ row.id)">Pembuatan BA</b-dropdown-item>
                                <b-dropdown-item @click="getDetailPerDokumen(row.id)">Memo Persetujuan</b-dropdown-item>
                            </b-dropdown> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- </div> -->
      <div class="d-flex justify-content-between mt-4">
        <div>
          <template v-if="pagination.total">
            Menampilkan {{ pagination.firstInPage }} sampai {{ pagination.currentPage !== pagination.lastPage ?
              pagination.limit * pagination.currentPage : pagination.total }} dari {{ pagination.total }} data
          </template>
        </div>
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li :class="['page-item', { 'disabled': pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'first' })">
                <span aria-hidden="true">Awal</span>
              </a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'prev' })">
                <span aria-hidden="true">Sebelumnya</span>
              </a>
            </li>
            <li v-for="i in pagination.pageNumber" class="page-item">
              <a :class="['page-link', { 'active': i === `${pagination.currentPage}` }]" href="#"
                @click="changePage({ page: i })">{{ i }}</a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'next' })">
                <span aria-hidden="true">Selanjutnya</span>
              </a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'last' })">
                <span aria-hidden="true">Akhir</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- modal nomor kkp -->
    <b-modal body-class="bg-white" id="modal-final-memo" title="Pemberian Nomor KKP" cancel-title="Close"
      ok-title="Accept" size="md" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>

          <b-col md="12">
            <b-form-group label="Nomor KKP: *">
              <input :class="{ 'form-control': true }" type="txt" v-validate="'required'" name="Nomor KKP"
                v-model="nomorMemo" />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Tanggal TTD MKP: *">
              <input type="date" v-validate="'required'" name="Tanggal TTD MKP" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Tanggal TTD MKP'),
              }" v-model="tanggal_ttd_mkp" />

            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="finalMemo">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal nomor memo -->
    <!-- <b-modal
      body-class="bg-white"
      id="modal-final-memo"
      title="Pemberian Nomor KKP"
      cancel-title="Close"
      ok-title="Accept"
      size="md"
      cancel-variant="outline-secondary"
    >
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="Nomor KKP: *">
              <input
                :class="{ 'form-control': true }"
                type="txt"
                v-validate="'required'"
                name="Nomor KKP"
                v-model="nomorMemo"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="finalMemo">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal> -->

    <!-- modal memo -->
    <b-modal body-class="bg-white" id="modal-memo" size="xl" title="Memo Persetujuan" cancel-title="Close"
      ok-title="Accept" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row v-if="this.dataPerDokumen.status_pembuatan_memorandum != null">
          <b-col v-if="
            this.dataPerDokumen.status_pembuatan_memorandum.includes(
              'Catatan'
            )
          " md="12">
            <b-alert show variant="info">
              <span><span class="fw-semi-bold">Info:</span> Terdapat Catatan
                Perbaikan.
                <a type="button" data-toggle="modal" data-target=".catatan"
                  class="btn btn-default btn-xs float-end me-1" @click="getCatatanMemo(dataPerDokumen.id)">Lihat
                  Catatan</a></span>
            </b-alert>
          </b-col>
        </b-row>
        <legend><strong>Memo 1</strong></legend>
        <b-row>
          <b-col md="4">
            <b-form-group label="Paraf Memo : *">
              <v-select id="default-select" v-model="dataPerDokumen.paraf_memo" :options="dataTTD"
                :reduce="(user) => user.id_user" v-validate="'required'" name="Paraf Memo"
                :class="{ 'is-invalid': errors.has('form-1.Paraf Memo') }" label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Paraf Memo')">
                {{ errors.first("form-1.Paraf Memo") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Tandatangan Memo : *">
              <v-select id="default-select" v-model="dataPerDokumen.ttd_memo_1" :options="dataTTD"
                v-validate="'required'" name="Tandatangan Memo"
                :class="{ 'is-invalid': errors.has('form-1.Tandatangan Memo') }" :reduce="(user) => user.id_user"
                label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Tandatangan Memo')">
                {{ errors.first("form-1.Tandatangan Memo") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <legend><strong>Memo 2</strong></legend>
        <b-row>
          <b-col md="4">
            <b-form-group label="Tandatangan Memo : *">
              <v-select id="default-select" v-model="dataPerDokumen.ttd_memo_2" :options="dataTTD"
                v-validate="'required'" name="Tandatangan Memo"
                :class="{ 'is-invalid': errors.has('form-1.Tandatangan Memo') }" :reduce="(user) => user.id_user"
                label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Tandatangan Memo')">
                {{ errors.first("form-1.Tandatangan Memo") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <legend><strong>Putusan</strong></legend>
        <b-row>

          <b-col md="4">
            <b-form-group label="Tandatangan Putusan : *">
              <v-select id="default-select" v-model="dataPerDokumen.ttd_putusan" :options="dataTTD"
                v-validate="'required'" name="Tandatangan Putusan" :class="{
                  'is-invalid': errors.has('form-1.Tandatangan Putusan'),
                }" :reduce="(user) => user.id_user" label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Tandatangan Putusan')">
                {{ errors.first("form-1.Tandatangan Putusan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="File Map Memo: ">
              <b-form-file placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." plain
                class="form-control" v-model="dataPerDokumen.file_map_memo" v-validate="'required'" name="File Map Memo"
                accept="image/*" :class="{ 'is-invalid': errors.has('form-1.File Map Memo') }"></b-form-file>
              <span class="text-danger" v-if="errors.has('form-1.File Map Memo')">
                {{ errors.first("form-1.File Map Memo") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="onSubmit">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal catatan memo -->
    <div class="modal fade catatan" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content" style="background-color: white">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Catatan</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: white">
            <div>
              <table id="example2" class="table" style="width: 100%">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Nama Pengirim</th>
                    <!-- <th>Jabatan Pengirim</th> -->
                    <th>Status</th>
                    <th>Catatan</th>
                    <th>Tanggal</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in dataCatatanMemo" :key="row.id">
                    <td></td>
                    <td>{{ row.nama_pengirim }}</td>
                    <!-- <td>
                                                {{row.jabatan_pengirim}}
                                            </td> -->
                    <td>
                      {{ row.status }}
                    </td>
                    <td>
                      <div v-html="row.isi_catatan"></div>
                    </td>
                    <td>
                      {{
                        new Date(row.createdAt).toLocaleDateString(
                          "id-ID",
                          options
                        )
                      }}
                      <br />
                      {{ new Date(row.createdAt).toLocaleTimeString() }}
                    </td>
                    <td>
                      <div>
                        <button data-toggle="modal" data-target="#modal-catatan" @click="getPerCatatanMemo(row.id)"
                          style="margin: 5px" class="btn btn-secondary">
                          <i class="fa fa-eye"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- modal detail catatan -->
    <div class="modal fade" id="modal-catatan" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
      aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Detail Catatan {{ detailCatatan.nama_pengirim }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: white">
            <form ref="form" @submit.stop.prevent="tambahcatatan">
              <b-col md="12">
                <div class="form-group">
                  <b-form-group label="Detail Catatan :">
                    <!-- <b-form-textarea
                                                id="textarea-formatter"
                                                v-html="detailCatatan.isi_catatan "
                                                
                                            ></b-form-textarea> -->
                    <ckeditor :editor="wygEditor" v-model="detailCatatan.isi_catatan"></ckeditor>
                  </b-form-group>
                </div>
              </b-col>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal body-class="bg-white" id="modal-bayar" title="Upload Pembayaran" cancel-title="Close" ok-title="Accept"
      cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-pembayaran">
        <b-row>
          <b-col md="12">
            <b-form-group label="File Bukti Pembayaran: *" label-for="username">
              <b-form-file placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." plain
                class="form-control" v-model="dataPerDokumen.bukti_pembayaran" accept=".pdf" v-validate="'required'"
                name="Bukti Pembayaran" :class="{
                  'form-control': true,
                  'is-invalid': errors.has('form-pembayaran.Bukti Pembayaran'),
                }"></b-form-file>
              <span class="text-danger" v-if="errors.has('form-pembayaran.Bukti Pembayaran')">
                {{ errors.first("form-pembayaran.Bukti Pembayaran") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label-for="Form Edit" label="Tanggal Pembayaran: *">
              <input type="date" v-validate="'required'" name="Tanggal Pembayaran" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-pembayaran.Tanggal Pembayaran'),
              }" v-model="dataPerDokumen.tanggal_pembayaran" />
              <span class="text-danger" v-if="errors.has('form-pembayaran.Tanggal Pembayaran')">
                {{ errors.first("form-pembayaran.Tanggal Pembayaran") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="onSubmitPembayaran">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal nomor memo -->
    <b-modal body-class="bg-white" id="modal-nomor-memo" title="Pemberian Nomor Memo" cancel-title="Close"
      ok-title="Accept" size="md" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="Nomor Memo 1: *">
              <input :class="{ 'form-control': true }" type="txt" v-validate="'required'" name="Nomor Memo 1"
                v-model="nomor_memo_1" />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Tanggal Memo 1: *">
              <input type="date" v-validate="'required'" name="Tanggal Memo 1" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Tanggal Memo 1'),
              }" v-model="tanggal_memo_1" />

            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Nomor Memo 2: *">
              <input :class="{ 'form-control': true }" type="txt" v-validate="'required'" name="Nomor Memo 2"
                v-model="nomor_memo_2" />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Tanggal Memo 2: *">
              <input type="date" v-validate="'required'" name="Tanggal Memo 2" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Tanggal Memo 1'),
              }" v-model="tanggal_memo_2" />

            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="penomoranMemo">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modalKonsepPersetujuan -->
    <b-modal body-class="bg-white" id="modal-konsepfilepersetujuan" title="Upload File Konsep Persetujuan"
      cancel-title="Close" ok-title="Accept" cancel-variant="outline-secondary">
      <form ref="form" data-vv-scope="form-konsepfilepersetujuan">
        <b-row>
          <b-col md="12">
            <b-form-group label="NIP: *" label-for="nip">
              <v-select id="default-select" v-model="dataPerDokumen.nip_composer" :options="dataNIP"
                :reduce="(data) => data.nip" v-validate="'required'" name="NIP"
                :class="{ 'is-invalid': errors.has('form-konsepfilepersetujuan.NIP') }" label="nama" />
              <span class="text-danger" v-if="errors.has('form-konsepfilepersetujuan.NIP')">
                {{ errors.first("form-konsepfilepersetujuan.NIP") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="File Konsep Persetujuan: *" label-for="file-st">

              <div class="border border-primary rounded p-4 text-center" @dragover.prevent
                @drop.prevent="handleDropFile" style="width: 100%;height: 100%;">
                <div class="mb-3">
                  <i class="fa fa-download text-primary fs-1"></i>
                </div>
                <p class="mb-3">Select a file or drag here</p>



                <div class="d-flex gap-2 justify-content-center">
                  <div
                    v-if="dataPerDokumen.file_persetujuan_konsep && typeof dataPerDokumen.file_persetujuan_konsep === 'string'">
                    <a :href="dataPerDokumen.file_persetujuan_konsep" target="_blank" class="btn btn-dark"><i
                        class="fa fa-file"></i> Lihat file saat ini</a>
                  </div>
                  <div>
                    <label class="btn btn-primary">
                      <i class="fa fa-upload"></i>
                      Select a file
                      <b-form-file v-model="dataPerDokumen.file_persetujuan_konsep" v-validate="'required'"
                        name="File Konsep Persetujuan" :class="{
                          'form-control': false,
                          'is-invalid': errors.has('form-konsepfilepersetujuan.File Konsep Persetujuan'),
                        }" class="d-none" @change="handleFileChange"></b-form-file>
                    </label>
                  </div>
                </div>


                <div v-if="selectedFile" class="mt-3 text-muted">
                  File selected: {{ selectedFile.name }}
                </div>
              </div>
              <span class="text-danger" v-if="errors.has('form-konsepfilepersetujuan.File Konsep Persetujuan')">
                {{ errors.first("form-konsepfilepersetujuan.File Konsep Persetujuan") }}
              </span>

            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Deskripsi Kesesuaian Ruang Laut: *" label-for="username">
              <b-form-textarea id="textarea" v-model="dataPerDokumen.deskripsi_kesesuaian_ruang_laut"
                placeholder="Masukkan Deskripsi Kesesuaian Ruang Laut" rows="3" max-rows="6" v-validate="'required'"
                name="Deskripsi Kesesuaian Ruang Laut" :class="{
                  'form-control': true,
                  'is-invalid': errors.has('form-konsepfilepersetujuan.Deskripsi Kesesuaian Ruang Laut'),
                }" />
              <span class="text-danger" v-if="errors.has('form-konsepfilepersetujuan.Deskripsi Kesesuaian Ruang Laut')">
                {{ errors.first("form-konsepfilepersetujuan.Deskripsi Kesesuaian Ruang Laut") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Deskripsi Verifikasi Lapangan:" label-for="username">
              <b-form-textarea id="textarea" v-model="dataPerDokumen.deskripsi_verifikasi_lapangan"
                placeholder="Masukkan Deskripsi Verifikasi Lapangan" rows="3" max-rows="6"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="simpanKonsepPersetujuan">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal finalisasi -->
    <b-modal body-class="bg-white" id="modal-finalisasi" title="Finalisasi Perizinan" cancel-title="Close"
      ok-title="Accept" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label-for="Form Edit" label="Nomor OSS: *">
              <b-form-input v-validate="'required'" name="Nomor OSS" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Nomor OSS'),
              }" id="name" type="text" v-model="dataPerDokumen.nomor_oss" />
              <span class="text-danger" v-if="errors.has('form-1.Nomor OSS')">
                {{ errors.first("form-1.Nomor OSS") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label-for="Form Edit" label="Tanggal Terbit OSS: *">
              <input type="date" v-validate="'required'" name="Tanggal Terbit OSS" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Tanggal Terbit OSS'),
              }" v-model="dataPerDokumen.tanggal_terbit_oss" />
              <span class="text-danger" v-if="errors.has('form-1.Tanggal Terbit OSS')">
                {{ errors.first("form-1.Tanggal Terbit OSS") }}
              </span>
            </b-form-group>
          </b-col>


          <b-col md="12">
            <b-form-group label="File Final OSS: *" label-for="File Final OSS">

              <div class="border border-primary rounded p-4 text-center" @dragover.prevent
                @drop.prevent="handleDropFileFinalOSS" style="width: 100%;height: 100%;">
                <div class="mb-3">
                  <i class="fa fa-download text-primary fs-1"></i>
                </div>
                <p class="mb-3">Select a file or drag here</p>



                <div class="d-flex gap-2 justify-content-center">
                  <div v-if="dataPerDokumen.file_final_oss && typeof dataPerDokumen.file_final_oss === 'string'">
                    <a :href="dataPerDokumen.file_final_oss" target="_blank" class="btn btn-dark"><i
                        class="fa fa-file"></i>
                      Lihat file saat ini</a>
                  </div>
                  <div>
                    <label class="btn btn-primary">
                      <i class="fa fa-upload"></i>
                      Select a file
                      <b-form-file v-model="dataPerDokumen.file_final_oss" v-validate="'required'" name="File Final OSS"
                        :class="{
                          'form-control': false,
                          'is-invalid': errors.has('form-1.File Final OSS'),
                        }" class="d-none" @change="handleFileChangeFinalOSS" accept=".pdf"></b-form-file>
                    </label>
                  </div>
                </div>


                <div v-if="selectedFileFinalOSS" class="mt-3 text-muted">
                  File selected: {{ selectedFileFinalOSS.name }}
                </div>
              </div>
              <span class="text-danger" v-if="errors.has('form-1.File Final OSS')">
                {{ errors.first("form-1.File Final OSS") }}
              </span>

            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="File SHP: *" label-for="File SHP">

              <div class="border border-primary rounded p-4 text-center" @dragover.prevent
                @drop.prevent="handleDropFileSHP" style="width: 100%;height: 100%;">
                <div class="mb-3">
                  <i class="fa fa-download text-primary fs-1"></i>
                </div>
                <p class="mb-3">Select a file or drag here</p>



                <div class="d-flex gap-2 justify-content-center">
                  <div v-if="dataPerDokumen.file_shp && typeof dataPerDokumen.file_shp === 'string'">
                    <a :href="dataPerDokumen.file_shp" target="_blank" class="btn btn-dark"><i class="fa fa-file"></i>
                      Lihat
                      file saat ini</a>
                  </div>
                  <div>
                    <label class="btn btn-primary">
                      <i class="fa fa-upload"></i>
                      Select a file
                      <b-form-file v-model="dataPerDokumen.file_shp" v-validate="'required'" name="File SHP" :class="{
                        'form-control': false,
                        'is-invalid': errors.has('form-1.File SHP'),
                      }" class="d-none" @change="handleFileChangeSHP" accept=".zip,.rar"></b-form-file>
                    </label>
                  </div>
                </div>


                <div v-if="selectedFileSHP" class="mt-3 text-muted">
                  File selected: {{ selectedFileSHP.name }}
                </div>
              </div>
              <span class="text-danger" v-if="errors.has('form-1.File SHP')">
                {{ errors.first("form-1.File SHP") }}
              </span>

            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="onFinalisasi">
            <i class="fa fa-check-circle text-white" />

            <span class="text-white"> Finalisasi Permohonan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import vSelect from "vue-select";
import axios from "axios";
import VueLoading from "vuejs-loading-plugin";
import Swal from "sweetalert2";
import * as xlsx from "xlsx";

// using default options
Vue.use(VueLoading);

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: "Loading", // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: "rgb(255,255,255)", // set custom background
  classes: ["myclass"], // array, object or string
});
export default {
  components: { ClassicEditor, vSelect },
  data() {
    return {
      baseapiCoofis: localStorage.getItem('baseapiCoofis'),
      tokenCoofis: localStorage.getItem('tokenCoofis'),
      fields: [
        "no",
        { key: "nama_pemohon", sortable: true },
        { key: "nomor_permohonan", sortable: true },
        { key: "jenis_kegiatan", sortable: true },
        {
          key: "status_verdok",
          label: "Status Verifikasi Dokumen",
          sortable: true,
        },
        {
          key: "status_vertek",
          label: "Status Penilaian Teknis",
          sortable: true,
        },
        { key: "tanggal_pada_permohonan", label: "Tanggal Permohonan" },
        { key: "tanggal_berlaku", label: "Tanggal Berlaku Tagihan" },
        { key: "tagihan", label: "Tagihan" },
        { key: "file_ba", label: "File BA" },
        { key: "file_memo", label: "File Memo" },
        "Aksi",
      ],
      optionsDatatable: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: "", count: "", limit: "" },
        columnsClasses: { id: "width-100" },
        skin: "table table-striped",
        sortIcon: {
          base: "fa text-muted",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
      },

      // currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      dataPerDokumen: [],
      wygEditor: ClassicEditor,
      dataTTD: [],
      dataPermohonan: [],
      dataCatatanMemo: [],
      detailCatatan: [],
      selectedFile: null,
      idpermohonan: null,
      nomorMemo: null,
      tanggal_ttd_mkp: null,
      nomor_memo_1: null,
      nomor_memo_2: null,
      tanggal_memo_1: null,
      tanggal_memo_2: null,

      pagination: {
        currentPage: parseInt(this.$route.query.page) || 1,
        lastPage: null,
        pageNumber: [],
        limit: 0,
        total: 0,
        firstInPage: 0,
      },
      search: {
        field: "nama_pemohon",
        value: "",
      },
      sort: {
        field: "createdAt",
        direction: "DESC",
      },
      debounceTerm: null,
      selectedFile: null,
      dataNIP: [],
      selectedNIP: null,
      selectedFileFinalOSS: null,
      selectedFileSHP: null,
      show: false
    };
  },
  props: {
    itemsWithNumber: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dataJenisProyek: {
      type: Array,
      default: () => {
        return [];
      },
    },
    user: {
      // type: Array,
      default: () => {
        return [];
      },
    },
    baseapi: String,
    dataRisiko: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dataSkalaUsaha: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dataStatusVerdok: {
      type: Array,
      default: () => {
        return [];
      },
    },
    rows: Number,

    totalRows: Number,
    currentPage: Number,
  },
  mounted() {
    this.getdata();
    this.getDataTTD();
    this.loadNIP()
  },
  methods: {
    onFiltered(data) {
      this.$emit("onFiltered", data);
    },
    pilihModal() {
      this.$emit("pilihModal");
    },
    deleteDokumen(data) {
      this.$emit("deleteDokumen", data);
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD MMMM YYYY");
      }
    },

    async getdata() {
      $("#berusahaPICMonitor").DataTable().destroy();
      await this.loaddata();
    },

    // finalMemo() {
    //   this.$validator.validateAll("form-1").then((result) => {
    //     if (result) {
    //       this.$nextTick(() => {
    //         this.$bvModal.hide("modal-final-memo");
    //       });
    //       this.$loading(true);
    //       axios
    //         .post(
    //           this.baseapi + "api/penambahan_kbli/" + this.idpermohonan,
    //           {
    //             // nomor_kkp: this.dataPerDokumen.nomor_kkp,
    //             status_pembuatan_memorandum: "Selesai",
    //           },
    //           {
    //             headers: {
    //               "Content-type": "application/json",
    //               Authorization: `Bearer ` + this.user.accessToken,
    //             },
    //           }
    //         )
    //         .then((res) => {
    //           this.$loading(false);
    //           this.$toasted.success("Berhasil Disimpan");
    //           this.getdata();
    //           this.dataPerDokumen = [];
    //           //   this.dataUser = []

    //           // Wait until the models are updated in the UI
    //           return res;
    //         })
    //         .catch((err) => {
    //           this.$loading(false);
    //           console.log(err);
    //           this.$toasted.error(err.response.data.message);
    //           return err;
    //         });
    //     }
    //   });
    // },

    // finalMemo() {
    //     this.$validator.validateAll('form-1').then((result) => {
    //         if (result) {
    //             this.$nextTick(() => {
    //                 this.$bvModal.hide('modal-final-memo')
    //             });
    //             this.$loading(true);
    //             axios.post(this.baseapi + 'api/penambahan_kbli/' + this.idpermohonan, {
    //                 nomor_kkp: this.nomorMemo,
    //                 "status_pembuatan_memorandum": "Selesai"
    //             },
    //                 {
    //                     headers: {
    //                         "Content-type": "application/json",
    //                         Authorization: `Bearer ` + this.user.accessToken
    //                     }
    //                 })
    //                 .then((res) => {
    //                     this.$loading(false);
    //                     this.$toasted.success("Berhasil Disimpan");
    //                     this.getdata()
    //                     this.dataPerDokumen = []
    //                     //   this.dataUser = []

    //                     // Wait until the models are updated in the UI
    //                     return res;
    //                 })
    //                 .catch((err) => {
    //                     this.$loading(false);
    //                     console.log(err)
    //                     this.$toasted.error(err.response.data.message);
    //                     return err;
    //                 });
    //         }
    //     })
    // },

    finalMemo() {
      this.$validator.validateAll('form-1').then((result) => {
        if (result) {
          this.$nextTick(() => {
            this.$bvModal.hide('modal-final-memo')
          });
          this.$loading(true);
          axios.post(this.baseapi + 'api/penambahan_kbli/' + this.idpermohonan, {
            nomor_kkp: this.nomorMemo,
            tanggal_ttd_mkp: this.tanggal_ttd_mkp
          },
            {
              headers: {
                "Content-type": "application/json",
                Authorization: `Bearer ` + this.user.accessToken
              }
            })
            .then((res) => {
              this.$loading(false);
              this.$toasted.success("Berhasil Disimpan");
              this.getdata()
              this.dataPerDokumen = []
              //   this.dataUser = []

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err)
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      })
    },

    initDatatable() {
      $.fn.dataTable.moment("DD MMMM YYYY");
      setTimeout(() => {
        var t = $("#berusahaPICMonitor").DataTable({
          pagingType: "full_numbers",
          language: {
            info: "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
            paginate: {
              first: "Awal",
              last: "Akhir",
              next: "Selanjutnya",
              previous: "Sebelumnya",
            },
          },
          // stateSave: true,
          // order: [[0, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: {
            left: 2,
            right: 1,
          },
          scrollX: true,
          dom: "Bfrtip",
          // fnRowCallback: function (
          //   nRow,
          //   aData,
          //   iDisplayIndex,
          //   iDisplayIndexFull
          // ) {
          //   //debugger;
          //   var index = iDisplayIndexFull + 1;
          //   $("td:first", nRow).html(index);
          //   return nRow;
          // },
          columnDefs: [
            {
              targets: 0,
              render: function (data, type, row, meta) {
                // console.log(meta.row);
                // console.log(type == "export" ? meta.row : data);
                return type == "export" ? meta.row + 1 : data;
              },
            },
          ],
          buttons: [
            // 'excel', 'pdf',
            // {
            //   extend: "excelHtml5",
            //   title: "DATA PEMOHON",
            //   text: '<i class="fa fa-file-text-o"></i> Excel',
            //   className: "btn text-white btn-success",
            //   exportOptions: {
            //     columns: [0,15,1, 2,9,3, 4, 5, 6, 7,11,12, 8],
            //     orthogonal: "export",
            //     // format: {
            //     //     header: function ( data, columnIdx ) {
            //     //         if(columnIdx==7 || columnIdx==8 || columnIdx==9){
            //     //         return 'Aktivitas ' + data;
            //     //         }
            //     //         else if(columnIdx==10 || columnIdx==11){
            //     //           return 'Verifikasi Dokumentatif ' + data;
            //     //         }
            //     //         else if(columnIdx==12 || columnIdx==13){
            //     //           return 'Verifikasi Lapangan ' + data;
            //     //         }
            //     //         else if(columnIdx==14 || columnIdx==15){
            //     //           return 'File BA ' + data;
            //     //         }
            //     //         else if(columnIdx==16 || columnIdx==17 || columnIdx==18){
            //     //           return 'Predikat ' + data;
            //     //         }
            //     //         else{
            //     //           return data;
            //     //         }
            //     //     },
            //     //     body: function(data, row, column, node) {
            //     //         data = $('<p>' + data + '</p>').text();
            //     //         return data.replace(',', '.');
            //     //     },
            //     // }
            //   },
            //   filename: function () {
            //     var today = new Date();
            //     // var n = d.getTime();
            //     var date =
            //       today.getFullYear() +
            //       "-" +
            //       (today.getMonth() + 1) +
            //       "-" +
            //       today.getDate();

            //     return "Data Pemohon " + date;
            //   },
            // },
          ],
        });
        // t.on("order.dt search.dt", function () {
        //   t.column(0, { search: "applied", order: "applied" })
        //     .nodes()
        //     .each(function (cell, i) {
        //       cell.innerHTML = i + 1;
        //     });
        // }).draw();
      }, 300);
    },

    loaddata() {
      this.show = true
      //   var api;
      //   if (this.user.role == 'pic') {
      //     api = 'api/penambahan_kbli?filter=pic_id,=,'+this.user.id
      //   } else {
      //     api = 'api/penambahan_kbli'
      //   }
      // const api = `api/penambahan_kbli/dataTable?page=${this.pagination.currentPage}&filter=pic_monitor_id,=,${this.user.id}${this.search.value ? `;${this.search.field},like,${this.search.value}` : ''}`
      const api = `api/penambahan_kbli/dataTable` +
        `?page=${this.pagination.currentPage}` +
        `&filter=pic_monitor_id,=,${this.user.id}${this.search.value !== '' ? `;${this.search.field},${this.search.field === 'tanggal_proses' || this.search.field === 'tanggal_pada_permohonan' ? '>=' : 'like'},${this.search.value}` : ''}` +
        `&sort=${this.sort.field},${this.sort.direction}`
      // "api/penambahan_kbli?filter=pic_monitor_id,=," + this.user.id,
      axios
        .get(
          this.baseapi + api,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          const data = response.data
          this.pagination.limit = data.limit
          this.pagination.total = data.total
          this.pagination.firstInPage = (this.pagination.currentPage - 1) * data.limit + 1
          this.pagination.lastPage = Math.ceil(data.total / data.limit)
          this.setPagination()
          this.dataPermohonan = response.data.data;

          for (let index = 0; index < this.dataPermohonan.length; index++) {
            Vue.set(this.dataPermohonan[index], "selectedFile", null);
          }
          this.initDatatable();
        })
        .catch((error) => {
          console.log(error);
          return error;
        }).finally(() => {
          this.show = false
        });
    },

    //Emit Check status pembayaran
    checkStatusBayar(data) {
      this.$emit("checkStatusBayar", data, "pic");
    },

    getBillingTerakhir(row) {
      if (row.kode_billing_tagihan_iii) {
        return {
          kode: row.kode_billing_tagihan_iii,
          status: row.status_tagihan_iii
        }
      }

      if (row.kode_billing_tagihan_ii) {
        return {
          kode: row.kode_billing_tagihan_ii,
          status: row.status_tagihan_ii
        }
      }

      if (row.kode_billing_tagihan_i) {
        return {
          kode: row.kode_billing_tagihan_i,
          status: row.status_tagihan_i
        }
      }

      return null
    },

    canCheckStatusBayar(row) {
      const billing = this.getBillingTerakhir(row)

      return billing && billing.status !== 'Sudah Dibayar'
    },


    setPagination() {
      this.$router.replace({
        path: this.$route.path,
        query: { page: this.pagination.currentPage },
      }).catch((err) => { })
      this.pagination.pageNumber = []
      if (this.pagination.lastPage > 7) {
        if (this.pagination.currentPage <= 4) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('2')
          this.pagination.pageNumber.push('3')
          this.pagination.pageNumber.push('4')
          this.pagination.pageNumber.push('5')
        } else if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 4}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 3}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 2}`)
        } else {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.currentPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage + 1}`)
        }
        if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        } else {
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        }
      } else {
        for (let i = 1; i <= this.pagination.lastPage; i++) {
          this.pagination.pageNumber.push(`${i}`)
        }
      }
    },

    async changePage(config = { option: 'next', page: null }) {
      if (config.option === 'next') {
        if (this.pagination.currentPage < this.pagination.lastPage) {
          this.pagination.currentPage++
        }
      }
      if (config.option === 'prev') {
        if (this.pagination.currentPage > 1) {
          this.pagination.currentPage--
        }
      }
      if (config.option === 'first') {
        this.pagination.currentPage = 1
      }
      if (config.option === 'last') {
        this.pagination.currentPage = this.pagination.lastPage
      }
      if (config.page) {
        if (config.page === '...') return
        this.pagination.currentPage = parseInt(config.page)
      }
      this.setPagination()
      await this.getdata()
      $('html,body').scrollTop(1000)
    },

    getBayar(id) {
      axios
        .get(this.baseapi + "api/penambahan_kbli/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPerDokumen = response.data.data;
          this.$bvModal.show("modal-bayar");
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    onSubmitPembayaran() {
      // console.log("cok");
      this.$validator.validateAll("form-pembayaran").then((result) => {
        if (result) {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-bayar");
          });
          this.$loading(true);
          let formData = new FormData();
          formData.append("bukti_pembayaran", this.dataPerDokumen.bukti_pembayaran);
          formData.append("tanggal_pembayaran", this.dataPerDokumen.tanggal_pembayaran);
          axios
            .post(
              this.baseapi + "api/penambahan_kbli/updatePembayaran/" + this.dataPerDokumen.id,
              formData,
              {
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$loading(false);
              this.$toasted.success("Berhasil Disimpan");
              this.dataPerDokumen = [];
              this.getdata();
              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err);
              this.$toasted.error(err.response.data.message);
              // this.$bvModal.hide('modal-pembayaran')
              return err;
            });
        }
      })
    },

    //Konsep File Persetujuan

    getDataUploadKonsep(data) {
      this.dataPerDokumen = data;
      this.$bvModal.show("modal-konsepfilepersetujuan");

    },

    simpanKonsepPersetujuan() {
      this.$validator.validateAll("form-konsepfilepersetujuan").then((result) => {
        if (result) {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-konsepfilepersetujuan");
          });

          this.$loading(true);
          let formData = new FormData();
          formData.append("nip_composer", this.dataPerDokumen.nip_composer);
          formData.append("file_persetujuan_konsep", this.dataPerDokumen.file_persetujuan_konsep)
          formData.append("deskripsi_kesesuaian_ruang_laut", this.dataPerDokumen.deskripsi_kesesuaian_ruang_laut)
          formData.append("deskripsi_verifikasi_lapangan", this.dataPerDokumen.deskripsi_verifikasi_lapangan)
          axios
            .post(
              this.baseapi + "api/penambahan_kbli/submitMemo/" + this.dataPerDokumen.id,
              formData,
              {
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {

              this.$toasted.success("Berhasil Disimpan");
              this.dataPerDokumen = [];
              this.getdata();
              return res;
            })
            .catch((err) => {
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            }).finally(() => {
              this.$loading(false);
            });
        }
      });
    },

    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    handleDropFile(event) {
      const files = event.dataTransfer.files;
      if (files.length) {
        this.selectedFile = files[0];
      }
    },


    //Kirim Dokumen ke Coofis
    kirimDocument(id) {
      Swal.fire({
        title: "Kirim Dokumen ke Coofis",
        text: "Apakah Anda yakin ingin mengirim dokumen ke Coofis?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, kirim"
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$loading(true)
          try {
            const response = await axios.put(`${this.baseapi}api/penambahan_kbli/sendDataCoofis/${id}`, {}, {
              headers: {
                "Content-type": "application/json",
                Authorization: `Bearer ` + this.user.accessToken,
              },
            })

            console.log(response)

            if (response.status == 200) {
              this.getdata()
              Swal.fire({
                title: "Berhasil",
                text: "Dokumen berhasil dikirim",
                icon: "success"
              });
            } else {
              Swal.fire({
                title: "Gagal",
                text: "Dokumen gagal dikirim",
                icon: "error"
              });
            }

          } catch (e) {
            Swal.fire({
              title: "Gagal",
              text: "Dokumen gagal dikirim",
              icon: "error"
            });
          } finally {
            this.$loading(false)
          }
        }
      });
    },


    //getDataFinalisasi
    getDetailPerDokumen(data) {
      this.dataPerDokumen = data;
      this.$bvModal.show("modal-finalisasi");
    },

    handleFileChangeFinalOSS(event) {
      this.selectedFileFinalOSS = event.target.files[0];
    },
    handleDropFileFinalOSS(event) {
      const files = event.dataTransfer.files;
      if (files.length) {
        this.selectedFileFinalOSS = files[0];
      }
    },

    // Helper method untuk mengecek apakah file berupa .zip atau .rar
    isValidCompressedFile(file) {
      if (!file) return false;

      const validExtensions = ['.zip', '.rar'];
      const fileName = file.name.toLowerCase();

      // 1. Cek berdasarkan ekstensi file
      const hasValidExtension = validExtensions.some(ext => fileName.endsWith(ext));

      // 2. Cek berdasarkan MIME Type
      const validMimeTypes = [
        'application/zip',
        'application/x-zip-compressed',
      ];
      const hasValidMimeType = validMimeTypes.includes(file.type);

      return hasValidExtension || hasValidMimeType;
    },

    handleFileChangeSHP(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (this.isValidCompressedFile(file)) {
        this.selectedFileSHP = file;
      } else {
        Swal.fire('Format Tidak Sesuai', 'Hanya berkas berformat .zip yang diperbolehkan!', 'warning');
        // Reset nilai input file agar file invalid tidak tersisa
        event.target.value = '';
      }
    },

    handleDropFileSHP(event) {
      const files = event.dataTransfer.files;
      if (files.length) {
        const file = files[0];
        if (this.isValidCompressedFile(file)) {
          this.selectedFileSHP = file;
        } else {
          Swal.fire('Format Tidak Sesuai', 'Hanya berkas berformat .zip yang diperbolehkan!', 'warning');
        }
      }
    },

    onFinalisasi() {
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-finalisasi");
          });
          this.$loading(true);
          let formData = new FormData();
          formData.append("nomor_oss", this.dataPerDokumen.nomor_oss);
          formData.append("tanggal_terbit_oss", this.dataPerDokumen.tanggal_terbit_oss);
          formData.append("file_final_oss", this.dataPerDokumen.file_final_oss);
          formData.append("file_shp", this.dataPerDokumen.file_shp);

          axios
            .post(
              this.baseapi + "api/penambahan_kbli/submitFinalisasi/" + this.dataPerDokumen.id,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$toasted.success("Berhasil Dikirim ke BHT");
              // this.$emit('loaddata')
              this.getdata();
              this.dataPerDokumen = [];

              // Wait until the models are updated in the UI
              // this.$nextTick(() => {
              //   this.$bvModal.hide('modal-finalisasi')
              // });
              return res;
            })
            .catch((err) => {

              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            }).finally(() => {
              this.$loading(false);
            });
        }
      });
    },


    // getDetailPerDokumen(id) {
    //   axios
    //     .get(this.baseapi + "api/penambahan_kbli/" + id, {
    //       headers: {
    //         Authorization: `Bearer ` + this.user.accessToken,
    //       },
    //     })
    //     .then((response) => {
    //       this.dataPerDokumen = response.data.data;
    //       if (this.dataPerDokumen.paraf_1_memo_1 == 0) {
    //         this.dataPerDokumen.paraf_1_memo_1 = null;
    //       }
    //       if (this.dataPerDokumen.paraf_1_memo_2 == 0) {
    //         this.dataPerDokumen.paraf_1_memo_2 = null;
    //       }

    //       if (this.dataPerDokumen.paraf_2_memo_1 == 0) {
    //         this.dataPerDokumen.paraf_2_memo_1 = null;
    //       }

    //       if (this.dataPerDokumen.paraf_2_memo_2 == 0) {
    //         this.dataPerDokumen.paraf_2_memo_2 = null;
    //       }

    //       if (this.dataPerDokumen.paraf_3_memo_2 == 0) {
    //         this.dataPerDokumen.paraf_3_memo_2 = null;
    //       }

    //       if (this.dataPerDokumen.paraf_1_putusan == 0) {
    //         this.dataPerDokumen.paraf_1_putusan = null;
    //       }

    //       if (this.dataPerDokumen.paraf_2_putusan == 0) {
    //         this.dataPerDokumen.paraf_2_putusan = null;
    //       }

    //       if (this.dataPerDokumen.paraf_3_putusan == 0) {
    //         this.dataPerDokumen.paraf_3_putusan = null;
    //       }

    //       if (this.dataPerDokumen.paraf_4_putusan == 0) {
    //         this.dataPerDokumen.paraf_4_putusan = null;
    //       }
    //       if (this.dataPerDokumen.paraf_5_putusan == 0) {
    //         this.dataPerDokumen.paraf_5_putusan = null;
    //       }

    //       if (this.dataPerDokumen.ttd_memo_1 == 0) {
    //         this.dataPerDokumen.ttd_memo_1 = null;
    //       }

    //       if (this.dataPerDokumen.ttd_memo_2 == 0) {
    //         this.dataPerDokumen.ttd_memo_2 = null;
    //       }

    //       if (this.dataPerDokumen.ttd_putusan == 0) {
    //         this.dataPerDokumen.ttd_putusan = null;
    //       }

    //       if (this.dataPerDokumen.status_pembuatan_memorandum != null) {
    //         if (
    //           this.dataPerDokumen.status_pembuatan_memorandum ===
    //           "Menunggu paraf dari Subkoordinator pada Memo Direktur ke Dirjen"
    //         ) {
    //           this.$bvModal.show("modal-memo");
    //         } else if (
    //           this.dataPerDokumen.status_pembuatan_memorandum.includes(
    //             "Menunggu"
    //           )
    //         ) {
    //           Swal.fire({
    //             icon: "info",
    //             title: this.dataPerDokumen.status_pembuatan_memorandum,
    //           });
    //         } else if (
    //           this.dataPerDokumen.status_pembuatan_memorandum.includes(
    //             "Catatan"
    //           )
    //         ) {
    //           // this.getCatatanMemo()
    //           Swal.fire({
    //             icon: "question",
    //             title: "Silahkan Pilih",
    //             showDenyButton: true,
    //             showCancelButton: true,
    //             confirmButtonText: "Unduh Memo",
    //             denyButtonText: `Perbaikan Memo`,
    //           }).then((result) => {
    //             /* Read more about isConfirmed, isDenied below */
    //             if (result.isConfirmed) {
    //               window.open(
    //                 this.dataPerDokumen.file_konsep_memorandum,
    //                 "_blank"
    //               );
    //             } else if (result.isDenied) {
    //               this.$bvModal.show("modal-memo");
    //             }
    //           });
    //         } else if (
    //           this.dataPerDokumen.status_pembuatan_memorandum.includes(
    //             "Sudah ditandatangani"
    //           )
    //         ) {
    //           this.$bvModal.show("modal-final-memo");
    //         } else if (
    //           this.dataPerDokumen.status_pembuatan_memorandum == "Selesai"
    //         ) {
    //           Swal.fire({
    //             icon: "info",
    //             title: "Unduh Surat Tugas",
    //             showDenyButton: false,
    //             showCancelButton: false,
    //             confirmButtonText: "Unduh",
    //           }).then((result) => {
    //             /* Read more about isConfirmed, isDenied below */
    //             if (result.isConfirmed) {
    //               window.open(
    //                 this.dataPerDokumen.file_final_memorandum,
    //                 "_blank"
    //               );
    //             }
    //           });
    //         }
    //       } else {
    //         this.$bvModal.show("modal-memo");
    //       }
    //       //   if (this.dataPerDokumen.status_pembuatan_memorandum.includes("Menunggu") ) {
    //       //         Swal.fire({
    //       //             icon: 'info',
    //       //             title: this.dataPerDokumen.status_pembuatan_memorandum ,
    //       //         })
    //       //     } else if (this.dataPerDokumen.status_pembuatan_memorandum.includes("Catatan") ) {
    //       //         this.getCatatanSurat()
    //       //         Swal.fire({
    //       //             icon: 'question',
    //       //             title: 'Silahkan Pilih',
    //       //             showDenyButton: true,
    //       //             showCancelButton: true,
    //       //             confirmButtonText: 'Unduh Memo',
    //       //             denyButtonText: `Perbaikan Memo`,
    //       //             }).then((result) => {
    //       //                 /* Read more about isConfirmed, isDenied below */
    //       //                 if (result.isConfirmed) {
    //       //                     window.open(this.dataPerDokumen.file_konsep_memorandum, '_blank');
    //       //                 } else if (result.isDenied) {
    //       //                     this.$bvModal.show('modal-memo')
    //       //                 }
    //       //             })
    //       //     } else if(this.dataPerDokumen.status_pembuatan_memorandum.includes("Sudah ditandatangani")){
    //       //         this.$bvModal.show('modal-final-memo')
    //       //     } else if (this.dataPerDokumen.status_pembuatan_memorandum  == 'Selesai'){
    //       //         Swal.fire({
    //       //             icon: 'info',
    //       //             title: 'Unduh Surat Tugas',
    //       //             showDenyButton: false,
    //       //             showCancelButton: false,
    //       //             confirmButtonText: 'Unduh',
    //       //             }).then((result) => {
    //       //             /* Read more about isConfirmed, isDenied below */
    //       //                 if (result.isConfirmed) {
    //       //                     window.open(this.dataPerDokumen.file_final_memorandum, '_blank');
    //       //                 }
    //       //             })
    //       //     }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       return error;
    //     });
    // },

    getCatatanMemo(id) {
      $("#example2").DataTable().destroy();
      axios
        .get(this.baseapi + "api/catatan_memo?filter=id_permohonan,=," + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataCatatanMemo = response.data.data;
          this.initDatatable2();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getPerCatatanMemo(id) {
      axios
        .get(this.baseapi + "api/catatan_memo/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.detailCatatan = [];
          this.detailCatatan.nama_pengirim = response.data.data.nama_pengirim;
          if (response.data.data.isi_catatan == null) {
            this.detailCatatan.isi_catatan = "";
          } else {
            this.detailCatatan.isi_catatan = response.data.data.isi_catatan;
          }
          // console.log(this.detailCatatan);
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    //Load Data NIP
    loadNIP() {
      axios
        .get(this.baseapi + "api/sync/getComposerMirror", {
          headers: {
            Authorization: this.tokenCoofis,
          },
        })
        .then((response) => {
          this.dataNIP = response.data.result;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    ///
    initDatatable2() {
      setTimeout(() => {
        var t = $("#example2").DataTable({
          pagingType: "full_numbers",
          language: {
            info: "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
            paginate: {
              first: "Awal",
              last: "Akhir",
              next: "Selanjutnya",
              previous: "Sebelumnya",
            },
          },
          // order: [[0, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: {
            left: 2,
            right: 1,
          },
          scrollX: true,
          // dom: 'Bfrtip',
          // "fnRowCallback": function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          //     //debugger;
          //     var index = iDisplayIndexFull + 1;
          //     $("td:first", nRow).html(index);
          //     return nRow;
          //   },
          //   columnDefs: [{
          //     targets: 0,
          //     render: function(data, type, row, meta) {
          //     console.log(meta.row);
          //     console.log(type == 'export'? meta.row : data);
          //       return type == 'export'? meta.row + 1 : data;
          //     }
          //   }],
        });

        // t.on( 'click', 'button', function (e) {
        //     var closestRow = $(this).closest('tr');
        //     var data = t.row( $(this).parents(closestRow)).data();
        //     alert(data[0])
        //     // alert( t.cell( $(this).closest('tr').prev('tr'), $(this).attr('data-dtr-index') ).data() );
        // e.stopPropagation();

        // } );
        t.on("order.dt search.dt", function () {
          t.column(0, { search: "applied", order: "applied" })
            .nodes()
            .each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
        }).draw();
      }, 300);
    },

    getDataTTD() {
      axios
        .get(this.baseapi + "api/tandatangan", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataTTD = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    onSubmit() {
      this.$nextTick(() => {
        this.$bvModal.hide("modal-memo");
      });
      this.$loading(true);
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          let formData = new FormData();
          formData.append("paraf_memo", this.dataPerDokumen.paraf_memo);
          formData.append("ttd_memo_1", this.dataPerDokumen.ttd_memo_1);
          formData.append("ttd_memo_2", this.dataPerDokumen.ttd_memo_2);
          formData.append("ttd_putusan", this.dataPerDokumen.ttd_putusan);
          formData.append("file_map_memo", this.dataPerDokumen.file_map_memo);
          axios
            .post(
              this.baseapi + "api/penambahan_kbli/" + this.dataPerDokumen.id,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$loading(false);
              this.$toasted.success("Berhasil Membuat Memo");
              this.getdata();
              this.dataPerDokumen = [];

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

    tandaTanganMKP(id) {
      Swal.fire({
        title: "Informasi",
        text: "Apakah Anda yakin ingin meminta tanda tangan elektronik Menteri Kelautan dan Perikanan?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$loading(true);
          axios
            .post(
              this.baseapi + "api/penambahan_kbli/" + id,
              {
                status_pembuatan_memorandum: "Menunggu tandatangan MKP",
              },
              {
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$loading(false);
              this.$toasted.success("Berhasil Disimpan");
              this.getdata();
              this.dataPerDokumen = [];
              //   this.dataUser = []

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

    tandaTanganDirjen(id) {
      Swal.fire({
        title: "Informasi",
        text: "Apakah Anda yakin ingin meminta tanda tangan memo Direktur Jendral?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$loading(true);
          axios
            .post(
              this.baseapi + "api/catatan_memo",
              {
                id_permohonan: id,
                status: "Menunggu tandatangan dari Dirjen",
              },
              {
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$loading(false);
              this.$toasted.success("Berhasil disubmit tanda tangan Memo Direktur Jendral");
              this.getdata();
              this.dataPerDokumen = [];
              //   this.dataUser = []

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

    penomoranMemo() {
      this.$validator.validateAll('form-1').then((result) => {
        if (result) {
          this.$nextTick(() => {
            this.$bvModal.hide('modal-nomor-memo')
          });
          this.$loading(true);
          axios.post(this.baseapi + 'api/penambahan_kbli/' + this.idpermohonan, {
            nomor_memo_1: this.nomor_memo_1,
            tanggal_memo_1: this.tanggal_memo_1,
            nomor_memo_2: this.nomor_memo_2,
            tanggal_memo_2: this.tanggal_memo_2,
          },
            {
              headers: {
                "Content-type": "application/json",
                Authorization: `Bearer ` + this.user.accessToken
              }
            })
            .then((res) => {
              this.$loading(false);
              this.$toasted.success("Berhasil Disimpan");
              this.getdata()
              this.dataPerDokumen = []
              //   this.dataUser = []

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err)
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      })
    },


    exportData() {
      this.$loading(true);
      const api = `api/penambahan_kbli` +
        `?sort=${this.sort.field},${this.sort.direction}` +
        `${this.search.value !== '' ? `&filter=${this.search.field},${this.search.field === 'tanggal_proses' || this.search.field === 'tanggal_pada_permohonan' ? '>=' : 'like'},${this.search.value}` : ''}`

      axios.get(this.baseapi + api, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then((res) => {
        const worksheetData = [
          ['Data Pemohon'],
          ['No', 'Prioritas', 'Nama Pemohon', 'Nomor Pemohon', 'Jenis Kegiatan', 'Nama Perairan', 'Provinsi', 'Status Verdok', 'Status Pentek', 'Tgl. Permohonan', 'Tgl. Proses', 'Tgl. Berlaku Tagihan', 'Status Tagihan', 'PIC Pentek'],
        ]
        const merge = [{ s: { c: 0, r: 0 }, e: { c: worksheetData[1].length - 1, r: 0 } }]

        res.data.data.forEach((d, i) => {
          worksheetData.push([
            i + 1,
            d.prioritas ? 'Prioritas' : '',
            d.nama_pemohon,
            d.nomor_permohonan,
            d.jenis_kegiatan,
            d.nama_perairan,
            d.lokasi,
            d.status_verdok,
            d.status_vertek,
            d.tanggal_pada_permohonan,
            d.tanggal_proses,
            d.tanggal_berlaku_hingga_tagihan_iii
              ? d.tanggal_berlaku_hingga_tagihan_iii
              : d.tanggal_berlaku_hingga_tagihan_ii
                ? d.tanggal_berlaku_hingga_tagihan_ii
                : d.tanggal_berlaku_hingga_tagihan_i
                  ? d.tanggal_berlaku_hingga_tagihan_i
                  : '',
            d.status_tagihan_iii
              ? d.status_tagihan_iii
              : d.status_tagihan_ii
                ? d.status_tagihan_ii
                : d.status_tagihan_i
                  ? d.status_tagihan_i
                  : '',
            d.pic_name,
          ])
        })

        const workbook = xlsx.utils.book_new();
        const worksheet = xlsx.utils.aoa_to_sheet(worksheetData);
        worksheet["!merges"] = merge;
        xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const d = new Date();
        xlsx.writeFile(workbook, `Data Pemohon ${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}.xlsx`);
      }).catch((err) => {
        Swal.fire('Gagal', 'Gagal mengekspor data', 'error')
      }).finally(() => {
        this.$loading(false);
      })
    }
  },
  watch: {
    search: {
      handler: function (val) {
        if (this.debounceTerm) {
          clearTimeout(this.debounceTerm)
        }
        this.debounceTerm = setTimeout(() => {
          this.pagination.currentPage = 1
          this.getdata();
        }, 1000)
      },
      deep: true,
    },
    sort: {
      handler: function (val) {
        this.pagination.currentPage = 1
        this.getdata();
      },
      deep: true,
    },
  },
};
</script>